<template>
    <div id="learning-journeys" class="margin-subpages" style="height: 100%;min-height: 800px;">
        
            <div class="flex-column mt-34">
                <div class="flex-row-between " style="width: 100%;">
                    <el-select v-model="selectTeam" filterable placeholder="Select" class="input-style"
                    :class="[ blurMode ?  'blurelement': '' ]" @change="handleTeams">
                        <el-option v-if="user.user_type !== 'leadership'" class="text-dropdown" key="all" :label="`All Teams (${$utils(
                        'addCommasInNumber',
                        optionsTeam.length
                    )})`" value="all"></el-option>
                        <el-option class="text-dropdown" 
                        :class="[ blurMode ?  'blurelement': '' ]"v-for="item in optionsTeam" :key="item.key" :label="item.name"
                        :value="item.key"></el-option>
                    </el-select>
                    <div style="width: 220px" id="menuDropdownType" class="flex">
                        <el-menu class="el-menu-demo menu-option-style" mode="horizontal">
                        <el-submenu index="0" style="width: 220px">
                            <template slot="title">
                            <span class="txtOption">{{ list_month_select }} </span>
                            </template>
                            <el-menu-item index="1" @click="changeTime('All-time')"
                            style="font-size: 14px; width: 220px">All-time</el-menu-item>
                            <el-menu-item index="2" @click="changeTime('Past year')" style="font-size: 14px; width: 220px">Past
                            year</el-menu-item>
                            <el-menu-item index="3" @click="changeTime('Past 6-months')" style="font-size: 14px; width: 220px">Past
                            6-months</el-menu-item>
                            <el-menu-item index="4" @click="changeTime('Past 3-months')" style="font-size: 14px; width: 220px">Past
                            3-months</el-menu-item>
                        </el-submenu>
                        </el-menu>
                    </div>
                </div>
                <div class="mt-24 fs-18 fw-700">
                    Overview
                </div>
                <div class="flex-row-between mt-10">
                    <div class="card-style flex-center">
                        <div>
                            <img
                            :src="$utils('icons', 'ic_activelearning')"
                            style="height: 48px;width: 48px;"
                            class="ml-12"
                            />
                        </div>
                        <div class="flex-column ml-12">
                            <div class="fs-11">Active Learning Journeys</div>
                            <div class="fs-20 fw-700">{{ overview.active }}</div>

                        </div>


                    </div>
                    <div class="card-style flex-center">
                        <div>
                            <img
                            :src="$utils('icons', 'ic_completed')"
                            style="height: 48px;width: 48px;"
                            class="ml-12"
                            />
                        </div>
                        <div class="flex-column ml-12">
                            <div class="fs-11">Completed Journeys</div>
                            <div class="fs-20 fw-700">{{ overview.completed }}</div>

                        </div>

                    </div>
                    <div class="card-style flex-center">
                        <div>
                            <img
                            :src="$utils('icons', 'ic_upskilled')"
                            style="height: 48px;width: 48px;"
                            class="ml-12"
                            />
                        </div>
                         
                            <div class="flex-column ml-12">
                            <div class="fs-11">Members Upskilled</div>
                            <div class="fs-20 fw-700">{{ overview.upskilling }}</div>
                            </div>

                    </div>
                    <div class="card-style flex-center">
                        <div>
                            <img
                            :src="$utils('icons', 'ic_learningtime')"
                            style="height: 48px;width: 48px;"
                            class="ml-12"
                            />
                        </div>
                        <div class="flex-column ml-12">
                            <div class="fs-11">Learning Time</div>
                            <el-tooltip :content="`${((overview.learning_time * 15)/60).toFixed(1)} hours` + ' or ' + `${((overview.learning_time * 15)/60/24).toFixed(1)} days`" placement="top" effect="light">
                                <div class="fs-20 fw-700">{{ (overview.learning_time * 15).toLocaleString() }} min</div>
                            </el-tooltip>
                        </div>

                    </div>
                  

                </div>
                <!-- chart -->
                
                    <div class="mt-24" style="height: 240px;background: #F7F7F7 0% 0% no-repeat padding-box;border-radius: 24px;opacity: 1;padding-left: 35px;">
                            <div class="mt-24 fs-14 fw-700"> Activation Channel</div>
                            <!-- pie chart -->
                            <div class="flex-center">
                                <div class="flex-column" style="width:293px;height:185;">
                                    <div class="fs-12" style="color: var(--unnamed-color-000000);opacity: 0.6;">Learning journeys initiated by managers (performance focus) or self-initiated (personal growth)</div>
                                    <div class="flex-row mt-12">
                                        <div style="width:120px;height:120px;">
                                        <canvas ref="pieChart" width="120" height="120"></canvas>
                                        </div>
                                        <div class="pl-20 mt-55">
                                            <div class="flex-row">
                                                <div class="label-pie mr-6" style="background-color: #32C2D5;"></div>
                                                <div class="fs-11" style="align-content:center">Manager</div>
                                            </div>
                                            <div class="flex-row mt-6">
                                                <div class="label-pie mr-6 " style="background-color: #6C30CC;"></div>
                                                <div class="fs-11" style="align-content:center">Self</div>
                                            </div>
                                        </div>
                                    
                                    </div>
                                
                                    
                                </div>
                                <!-- bar chart -->
                                <div class="flex-center" style="width: 480px;height: 125px;margin-left: 24px;">
                                        <canvas
                                            ref="barChart"
                                            height="120px"
                                            class="barchart-style"
                                        ></canvas>
                                    </div>

                            </div>
                    </div>
                

                <!-- Top Learners Section -->
                <div class="mt-24 compact-section">
                    <div class="flex-row-between">
                        <div>
                            <div class="fs-14 fw-700">Top Learners</div>
                            <div class="fs-11 section-subtitle">Team members with the most learning journeys</div>
                        </div>
                        <div>
                            <span class="view-all-btn" @click="openTopLearnersModal">View All</span>
                        </div>
                    </div>
                    
                    <div class="top-learners-grid mt-8">
                        <div v-for="(learner, index) in topSixLearners" :key="index" class="top-learner-item">
                            <div class="learner-rank">{{ index + 1 }}</div>
                            <div class="learner-profile">
                                <img 
                                    :src="learner.pic || getDefaultAvatar(learner.name)" 
                                    class="learner-avatar"
                                    alt="Learner avatar"
                                />
                            </div>
                            <div class="learner-info">
                                <div class="learner-name">{{ learner.name }}</div>
                                <div class="learner-journeys">{{ learner.count }} {{ learner.count === 1 ? 'Journey' : 'Journeys' }}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="flex-center mt-32">
                    <div class="fs-18 fw-700">Learning Journey Progress</div>
                    <div class="ml-24"> 
                        <el-input
                        class="input-style"
                        style="width: 220px !important;height: 40px !important;"
                        autosize
                        :placeholder="$t('global.Search')"
                        v-model="inputSearch"
                        clearable
                    ></el-input>
                    </div>
                    <div style="margin-left: 144px;">Status</div>
                    <div style="width: 200px; margin-left: 24px;" id="menuDropdownType" class="flex">
                            <el-menu class="el-menu-demo menu-option-style" mode="horizontal">
                            <el-submenu index="0" style="width: 200px">
                                <template slot="title">
                                <span class="txtOption">{{ statusLearning }} </span>
                                </template>
                                <el-menu-item index="0" @click="changeStatus('All')" style="font-size: 14px; width: 200px">All</el-menu-item>
                                <el-menu-item index="1" @click="changeStatus('Not Started')" style="font-size: 14px; width: 200px">Not Started</el-menu-item>
                                <el-menu-item index="2" @click="changeStatus('In Progress')" style="font-size: 14px; width: 200px">In Progress</el-menu-item>
                                <el-menu-item index="3" @click="changeStatus('Completed')" style="font-size: 14px; width: 200px">Completed</el-menu-item>
                            </el-submenu>
                            </el-menu>
                    </div>
                        

                </div>


                <!-- title -->
                <div class="flex-row mt-24">
                    <div class="fs-14 fw-700" style="width: 280px;">Skill Set</div>
                    <div class="fs-14 fw-700" style="width: 180px;">Progress</div>
                    <div class="fs-14 fw-700" style="width: 110px;">Initiated by</div>
                    <div class="fs-14 fw-700" style="width: 150px;">Assigned To</div>
                    <div class="fs-14 fw-700" style="width: 120px;">Date & time</div>
                </div>

                <div v-if="loading"  class="flex-row mt-24" style="align-items: center;justify-content: center;">
                    <loading-even/>
                </div>
                <div v-else>
                    <div class="mt-24">
                        <div v-for="arr in learningprogress" :key="arr.id" >
                        <div class="relative">
                            <div
                                class="card-layer"
                                style="top: 16px; left: 16px"
                                >
                                &nbsp;
                            </div>
                            <div
                                class="card-layer"
                                style="top: 8px; left: 8px"
                                >
                                &nbsp;
                            </div>
                            <div
                                class="card-layer"
                                style="top: 0px; left: 0px;position: relative !important;margin-bottom: 32px;"
                                @click="openModal(arr)"
                                >
                            
                                <div class="flex-row" style="width: 100%;align-items: center;">
                                    <div class="fs-14 fw-700 ml-32" style="width: 250px;">{{ arr.name }}</div>
                                    <div class="fs-14 flex-center" style="width: 180px;">
                                        <div class="progress-bar">
                                            <div class="progress-bar-fill" :style="{ width: arr.progress + '%' }"></div>
                                        </div>
                                        <div class="fs-11 ml-12">{{ arr.progress }}%</div>    
                                    </div>
                                    <div style="width: 100px;">
                                        <div class="initiated-tag" :class="arr.initiated.toLowerCase() === 'self' ? 'self-tag' : 'manager-tag'">
                                            {{ arr.initiated }}
                                        </div>
                                    </div>
                                    <div class="fs-13" style="width: 150px;">
                                        <div class="flex-center">
                                            <img 
                                                v-if="arr.pic || arr.members"
                                                :src="arr.pic || getDefaultAvatar(arr.members)" 
                                                class="avatar"
                                                :class="{'image-skeleton': !arr.pic}"
                                                alt="User avatar"
                                            />
                                            <div class="fs-13 ml-8">{{ arr.members ? arr.members.split(' ')[0] + ' ' + (arr.members.split(' ')[1] ? arr.members.split(' ')[1][0] : '') : '' }}</div>
                                        </div>
                                    </div>
                                    <div class="fs-13" style="width: 120px;">{{ convertDate(arr.date) }}</div>
                                    <div style="width: 25px;" class="expand-icon-container">
                                        <img
                                        :src="$utils('icons', 'Ic_read')"
                                        style="height: 24px;width: 24px; cursor: pointer;"
                                        class="ml-12 expand-icon"
                                        @click.stop="openModal(arr)"
                                        />
                                    </div>

                                </div>
                                
                            </div>



                        </div>

                        </div>

                    </div>
                </div>
               
            </div>


            <el-dialog id="learning-journeys-dialog" :visible.sync="detailsModal" width="922px" height="847px" top="8vh"> 
                    <div class="flex-center" style="background-color:#F8F8F8;">
                        <div class="modal-1" style="width:402px;">
                            <div class="flex-column">
                                <div class="fs-18 fw-700 mt-32 fc-000000">{{ card.name }}</div>
                                <div>
                                    <div class="flex-row-between" style="margin-top: 27px;">
                                        <div class="flex-row" style="align-items: center;">
                                            <div class="fs-11" style="background: var(--unnamed-color-e6e7e8) 0% 0% no-repeat padding-box;
                                                background: #e6e7e8 0% 0% no-repeat padding-box;
                                                border-radius: 3px;padding: 4px 8px;
                                                ">{{ card.members_name }}</div>
                                            <div class="fs-12 pl-12">{{ card.date_show }}</div>
                                        </div>
                                        <div class="fs-12">{{ data_detail.length }} cards</div>
                                    </div>
                                </div>


                                <div class="mt-15">
                                    <div v-for="(arr,index) in data_detail" :key="`detail_index_${index}`" style="width: 322px;">
                                   
                                        <div class="card-detail" @click="onClickCard(arr)" 
                                            :class="{ 
                                                'card-detail-active': arr.focus,
                                                'card-completed': arr.status === 'completed',
                                                'card-in-progress': arr.status === 'in-progress',
                                                'card-not-started': arr.status === 'not-started'
                                            }">
                                            <div class="flex-row-between" style="align-items: center;height: 100%;">
                                                <div class="fs-16 fw-700 pl-14">{{arr.title}}</div>
                                                <div class="flex-row" style="align-items: center;">
                                                    <div class="card-status-indicator" v-if="arr.status === 'completed'">
                                                        <img :src="$utils('icons', 'ic_completed')" style="height: 18px;width: 18px;" />
                                                    </div>
                                                    <div class="card-status-indicator in-progress" v-else-if="arr.status === 'in-progress'">
                                                        <div class="progress-dot"></div>
                                                    </div>
                                                    <div class="fs-16 fw-700 pr-14">{{index+1}}</div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>

                        </div>


                        <div class="modal-2" style="width: 510px;">
                            <div class="flex-column" style="margin-top: 59px;">
                                <div class="content-card">
                                    <div class="content-card-header">
                                        <div class="header-text">{{ card.name }}</div>
                                    </div>
                                    
                                    <div class="content-card-body">
                                        <div class="header-text">{{ data_detail_selected.title }}</div>
                                        <div class="content-text" v-html="data_detail_selected.body"></div>
                                        
                                        <div class="instruction-box" v-if="data_detail_selected.nudge">
                                            {{ data_detail_selected.nudge }}
                                        </div>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-dialog>
               
            <!-- Top Learners Modal -->
            <el-dialog 
                id="top-learners-modal" 
                :visible.sync="topLearnersModal" 
                width="850px"
                :show-close="true"
                :close-on-click-modal="true"
                custom-class="top-learners-dialog">
                <div slot="title" class="modal-title">
                    <span>Top Learners</span>
                </div>
                <div class="top-learners-modal-content">
                    <div class="learners-header">
                        <div class="learners-explanation">
                            Team members who have participated in the most learning journeys during the selected time period
                        </div>
                        <div class="top-learners-search">
                            <el-input
                                placeholder="Search member"
                                v-model="learnersSearch"
                                clearable
                                prefix-icon="el-icon-search"
                                size="small">
                            </el-input>
                        </div>
                    </div>
                    
                    <div class="top-learners-list-container">
                        <div class="top-learners-list">
                            <div v-for="learner in paginatedLearners" :key="learner.email" class="top-learner-row">
                                <div class="top-learner-rank-modal">{{ findLearnerRank(learner) }}</div>
                                <div class="top-learner-info-modal">
                                    <img 
                                        :src="learner.pic || getDefaultAvatar(learner.name)" 
                                        class="top-learner-avatar-modal"
                                        alt="Learner avatar"
                                    />
                                    <div class="top-learner-details">
                                        <div class="top-learner-name-modal">{{ learner.name }}</div>
                                        <div class="top-learner-count-modal">{{ learner.count }} {{ learner.count === 1 ? 'Journey' : 'Journeys' }}</div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="filteredLearners.length === 0" class="no-results">
                                No learners found matching your search.
                            </div>
                        </div>
                    </div>
                    
                    <div class="modal-footer" v-if="filteredLearners.length > 0">
                        <div class="total-count">Total: {{ filteredLearners.length }} {{ filteredLearners.length === 1 ? 'Learner' : 'Learners' }}</div>
                        <div class="pagination-container">
                            <el-pagination
                                @current-change="handlePageChange"
                                :current-page.sync="currentPage"
                                :page-size="pageSize"
                                layout="prev, pager, next"
                                :total="filteredLearners.length">
                            </el-pagination>
                        </div>
                    </div>
                </div>
            </el-dialog>

        
    </div>
    
    
</template>
  
  <script>
  import Chart from "chart.js/auto";
  import format from 'date-fns/format'
  import subMonths from 'date-fns/sub_months'
  import subYears from 'date-fns/sub_years'
  import _ from 'lodash'
  
  export default {
    name: "learning-journeys",
    components: {
      loadingEven: require("../even/loading").default,
    },
    created() {
        this.$store.dispatch("learningJourneys/getLearningJourneys");
        

    },
    watch: {
        pieChart() {
            this.destroyAndCreatePieChart();
        },
        barChart(){
            this.destroyAndCreateBarChart();
        },
        inputSearch: {
            handler(newVal) {
                this.$store.dispatch("learningJourneys/searchdatatable", newVal)
            },
            deep: true
        }
    },
    computed: {
        blurMode() {
            return this.$store.getters["demomode/blurMode"];
        },
        optionsTeam() {
            return this.$store.getters["team/teamsfixedall"];
        },
        user() {
            return this.$store.getters["authen/user"];
        },
        overview(){
            return this.$store.getters["learningJourneys/overview"];
        },
        pieChart(){
            return this.$store.getters["learningJourneys/pieChart"];
        },
        barChart(){
            return this.$store.getters["learningJourneys/barChart"];
        },
        learningprogress(){
            return this.$store.getters["learningJourneys/datatable"];
        },
        loading(){
            return this.$store.getters["learningJourneys/loading"];
        },
        topSixLearners() {
            return this.$store.getters["learningJourneys/topSixLearners"];
        },
        allTopLearners() {
            // Return all top learners (no limit) - used in the modal
            return this.$store.getters["learningJourneys/topLearners"];
        },
        filteredLearners() {
            const allLearners = this.allTopLearners;
            const search = this.learnersSearch.toLowerCase();
            
            if (search === '') {
                return allLearners;
            }
            
            return allLearners.filter(learner => 
                learner.name.toLowerCase().includes(search)
            );
        },
        paginatedLearners() {
            const start = (this.currentPage - 1) * this.pageSize;
            const end = start + this.pageSize;
            return this.filteredLearners.slice(start, end);
        }
    },
    data() {
      return {
        reload:true,
        selectTeam: 'all',
        statusLearning:'In Progress',
        list_month_select: "Past 6-months",
        myChart: '',
        mybarChart: '',
        inputSearch: '',
        detailsModal:false,
        topLearnersModal: false,
        data_detail:[],
        card:{},
        data_detail_selected: [],
        learnersSearch: '',
        currentPage: 1,
        pageSize: 10
      };
    },
    mounted() {
        if (this.optionsTeam.length > 0 && this.selectTeam == "") {
            this.selectTeam = this.user.user_type == "leadership" ? this.user.team : "all";
        }
        this.createPieChart();
        this.createBarChart();
        this.$store.dispatch("learningJourneys/getLearningJourneys");
    },
    methods: {
        convertDate(date) {
            if (!date) return '';
            
            // Split the date string to separate date and time parts
            const dateParts = date.split(' ');
            const dateStr = dateParts[0];
            const timeStr = dateParts.length > 1 ? dateParts[1] : '';
            
            // Parse the date
            const dateObj = new Date(dateStr);
            const today = new Date();
            const yesterday = new Date(today);
            yesterday.setDate(yesterday.getDate() - 1);
            
            // Format the date based on when it occurred
            if (format(dateObj, 'YYYY-MM-DD') === format(today, 'YYYY-MM-DD')) {
                return `Today at ${timeStr.substring(0, 5)}`;
            } else if (format(dateObj, 'YYYY-MM-DD') === format(yesterday, 'YYYY-MM-DD')) {
                return `Yesterday at ${timeStr.substring(0, 5)}`;
            } else {
                // For older dates, show month and day without year
                const formattedDate = format(dateObj, 'MMM DD');
                return timeStr ? `${formattedDate} at ${timeStr.substring(0, 5)}` : formattedDate;
            }
        },
        onClickCard(arr){
            //console.log('onClickCard',arr)
            this.data_detail_selected=arr
            for(let i=0;i<this.data_detail.length;i++){
                this.data_detail[i].focus=false
            }
            arr.focus=true
        },
        openModal(arr){
            //console.log('openModal',arr)
            const arr_value=_.cloneDeep(arr)
            arr_value.date_show=format(arr.date,'MMM DD, YYYY')
            const datadetail=JSON.parse(arr.response)
            //console.log('datadetail',datadetail.cards)
            
            // Calculate the journey's overall progress percentage
            const overallProgress = arr.progress || 0;
            const totalCards = datadetail.cards.length;
            
            // Determine how many cards are completed based on the progress
            const completedCardCount = Math.floor((overallProgress / 100) * totalCards);
            
            // Mark cards as completed or in progress based on overall progress
            for(let i=0; i < datadetail.cards.length; i++){
                datadetail.cards[i].focus = false;
                
                // Mark cards as completed, in progress, or not started
                if (i < completedCardCount) {
                    datadetail.cards[i].status = 'completed';
                } else if (i === completedCardCount && overallProgress > 0 && overallProgress < 100) {
                    datadetail.cards[i].status = 'in-progress';
                } else {
                    datadetail.cards[i].status = 'not-started';
                }
            }
            
            datadetail.cards[0].focus = true;
            this.data_detail = datadetail.cards;
            this.data_detail_selected = datadetail.cards[0];
            this.card = arr_value;
            this.detailsModal = true;
        },

        closeModal(){
            this.detailsModal=false
        },
        destroyAndCreatePieChart() {
            if (this.myChart) {
                this.myChart.destroy();
                this.myChart = null;
            }
            this.$nextTick(() => {
                this.createPieChart();
            });
        },
        destroyAndCreateBarChart() {
            if (this.mybarChart) {
                this.mybarChart.destroy();
                this.mybarChart = null;
            }
            this.$nextTick(() => {
                this.createBarChart();
            });
        },
        changeTime(val){
            this.list_month_select = val;
            //console.log('changeTime')
            this.$store.dispatch("learningJourneys/filterPeriod", val)
        },
        handleTeams(val){
            this.selectTeam = val;
            //('handleTeams')
            this.$store.dispatch("learningJourneys/changeTeam", val)
        },
        createPieChart() {
        //console.log('createChart')
        // console.log('this.datachart',this.datachart)
        var pieChart = this.$refs.pieChart;
        

        if (pieChart) {
            const data = {

            datasets: [{
                label: 'Rating overview',
                data:[this.pieChart?this.pieChart.manager:0, this.pieChart?this.pieChart.self:0],
                backgroundColor: [
                '#32C2D5',
                '#6C30CC',
                
               
                ],
                hoverOffset: 6
            }],
            };
            this.myChart = new Chart(pieChart, {
            type: "pie",
            data:data ,
                });
            }
            },
        createBarChart(){
            //console.log('createBarChart',this.barChart)
            var barChart = this.$refs.barChart;
            const month = []
            const self = []
            const manager = []
                if(this.list_month_select=='All-time'){
                    for(let i=0;i<12;i++){
                        month.unshift(format(subMonths(new Date(), i), 'MMM'))
                        const month_bar = format(subMonths(new Date(), i), 'YYYY-MM')
                        
                        if(this.barChart&&this.barChart[month_bar]){
                            self.unshift(this.barChart[month_bar].self)
                            manager.unshift(this.barChart[month_bar].manager)
                        }else{
                            self.unshift(0)
                            manager.unshift(0)
                        }

                    }
                
                }else if(this.list_month_select=='Past year'){
                    for(let i=0;i<12;i++){
                        const past_year = format(subYears(new Date(), 1), 'YYYY-12')
                        const past_year_bar = format(subMonths(past_year, i), 'YYYY-MM')
                        //console.log('past_year_bar',past_year_bar)
                        month.unshift(format(subMonths(new Date(past_year), i), 'YYYY-MMM'))
                        const month_bar = format(subMonths(new Date(past_year), i), 'YYYY-MM')
                        if(this.barChart&&this.barChart[month_bar]){
                            self.unshift(this.barChart[month_bar].self)
                            manager.unshift(this.barChart[month_bar].manager)
                        }else{
                            self.unshift(0)
                            manager.unshift(0)
                        }

                    }
                    
                }else if(this.list_month_select=='Past 6-months'){
                    for(let i=0;i<6;i++){
                        month.unshift(format(subMonths(new Date(), i), 'MMM'))
                        const month_bar = format(subMonths(new Date(), i), 'YYYY-MM')
                        
                        if(this.barChart&&this.barChart[month_bar]){
                            self.unshift(this.barChart[month_bar].self)
                            manager.unshift(this.barChart[month_bar].manager)
                        }else{
                            self.unshift(0)
                            manager.unshift(0)
                        }

                    }
                }else if(this.list_month_select=='Past 3-months'){
                    
                    for(let i=0;i<3;i++){
                        month.unshift(format(subMonths(new Date(), i), 'MMM'))
                        const month_bar = format(subMonths(new Date(), i), 'YYYY-MM')
                        if(this.barChart&&this.barChart[month_bar]){
                            self.unshift(this.barChart[month_bar].self)
                            manager.unshift(this.barChart[month_bar].manager)
                        }else{
                            self.unshift(0)
                            manager.unshift(0)
                        }

                    }
                }
            //console.log('month',month)
            if (barChart) {
                const data = {
                    labels: month,
                    datasets: [{
                        label: 'Manager',
                        data: manager,
                        backgroundColor: '#32C2D5',
                        borderColor: '#32C2D5',
                        borderWidth: 1
                    },{
                        label: 'Self',
                        data: self,
                        backgroundColor: '#6C30CC',
                        borderColor: '#6C30CC',
                        borderWidth: 1
                    }]
                };
                this.mybarChart = new Chart(barChart, {
                    type: 'bar',
                    data: data,
                    options: {
                        plugins: {
                            legend: {
                                display: false 
                            }
                        },
                        scales: {
                            y: {
                                min: 0,
                                
                                grid: {
                                    borderDash: [5, 5], 
                                    drawBorder: false,  
                                    color: 'rgba(0, 0, 0, 0.1)' 
                                },
                                ticks: {
                                    callback: function(value, index, ticks) {
                                        if (value === 0 || value === Math.max(...ticks.map(t => t.value))) {
                                            return value;
                                        }
                                        return '';
                                    }
                                },
                                
                            },
                            x: {
                                grid: {
                                    display: false 
                                }
                            }

                        }
                    }
                });
            }
        },
        changeStatus(val){
            this.statusLearning = val;
            //console.log('changeStatus')
            this.$store.dispatch("learningJourneys/filterStatus", val)
        },
        getDefaultAvatar(name = '') {
            // Extract initials from the name
            const initials = name
                .split(' ')
                .map(part => part.charAt(0))
                .join('')
                .toUpperCase()
                .substring(0, 2) || 'U';
            
            // Create SVG for the avatar
            const backgroundColor = '5C21E0'; // Purple background
            const svg = `
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
                <rect width="40" height="40" fill="#${backgroundColor}"/>
                <text x="50%" y="50%" dy=".1em" fill="white" font-family="Lato, sans-serif" 
                        font-size="16" font-weight="normal" text-anchor="middle" dominant-baseline="middle">
                    ${initials}
                </text>
                </svg>
            `;
            
            // Convert SVG to a data URL
            const dataUrl = 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(svg)));
            return dataUrl;
        },
        openTopLearnersModal() {
            this.topLearnersModal = true;
        },
        handlePageChange(newPage) {
            this.currentPage = newPage;
        },
        findLearnerRank(learner) {
            const allLearners = this.allTopLearners;
            const sortedLearners = [...allLearners].sort((a, b) => b.count - a.count);
            const rank = sortedLearners.findIndex(l => l.email === learner.email) + 1;
            return rank;
        }
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .txtOption {
  color: #4a4a4a;
  font-size: 14px;
  margin-left: 16px;
  width: 158px;
  display: inline-block;
}

.menu-option-style {
  border-bottom: transparent;
  background: #f4f4f4;
  border-radius: 4px;
}
  #menuDropdownType .el-submenu__title {
  height: 40px;
  line-height: 40px;
  background-color: #f4f4f4;
}
.card-style{
    width: 210px;
    height: 72px;
    background: var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #0000001F;
    border-radius: 4px;
    opacity: 1;
}

.card-style-content-green-icon{
    margin-left: 12px;
    width: 48px;
    height: 48px;
    background: #DCFCE7 0% 0% no-repeat padding-box;
    border-radius: 4px;
    opacity: 1;
}
.card-style-content-pink-icon{
    margin-left: 12px;
    width: 48px;
    height: 48px;
    background: #FEE2E2 0% 0% no-repeat padding-box;
    border-radius: 4px;
    opacity: 1;
}
.card-style-content-yellow-icon{
    margin-left: 12px;
    width: 48px;
    height: 48px;
    background: #FEF9C3 0% 0% no-repeat padding-box;
    border-radius: 4px;
    opacity: 1;
}
.label-pie{
    width: 16px;
    height: 16px;
    background: var(--unnamed-color-32c2d5) 0% 0% no-repeat padding-box;
    border-radius: 4px;
    opacity: 0.8;
}
.card-layer {
    box-shadow: 0px 1px 4px #00000029;
    border-radius: 9px;
    padding: 0 4px;
    font-size: 13px;
    height: 64px;
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    width: 100%;
    padding: 0;
    position: absolute;
    background: #FCFAFF 0% 0% no-repeat padding-box;
    transition: all 0.25s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    opacity: 1;
}

.relative {
    position: relative;
    cursor: pointer;
}

.relative:hover .card-layer:nth-child(1) {
    transform: translateY(-8px);
    opacity: 0.9;
}

.relative:hover .card-layer:nth-child(2) {
    transform: translateY(-4px);
    opacity: 0.95;
}

.relative:hover .card-layer:nth-child(3) {
    transform: translateY(-1px) scale(1.01);
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.12);
    background: #F7F3FF 0% 0% no-repeat padding-box;
    cursor: pointer;
}

.relative:active .card-layer:nth-child(1) {
    transform: translateY(-4px);
}

.relative:active .card-layer:nth-child(2) {
    transform: translateY(-2px);
}

.relative:active .card-layer:nth-child(3) {
    transform: translateY(0) scale(1);
    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
}

.card {
  position: relative;
  height: 100px
}
.progress-bar{
    width:125px;
    height: 10px;
    position: relative;
    background-color: #00000015;
    border-radius: 4px;
}
.progress-bar-fill{
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    background-color: #6C30CC;
    border-radius: 4px;
}
.avatar {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  object-fit: cover;
}
.modal-1{
    overflow-y: scroll;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    border-radius: 0px 40px 40px 0px;
    opacity: 1;
    height: 84vh;
    min-height: 847px;
    padding-left: 40px;
    padding-right: 34px;
    max-height: 1200px;

}
.modal-2{
  overflow-y: scroll;
  background: #F8F8F8 0% 0% no-repeat padding-box;
  opacity: 1;
  height: 84vh;
  padding-left: 42px;
  padding-right: 42px;
  min-height: 847px;
  max-height: 1200px;
  position: relative;
}
.card-detail{
    width: 322px;
    height: 60px;
    cursor: pointer;
    background: var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 1px 4px #00000029;
    border-radius: 9px;
    opacity: 1;
    border: 1px solid transparent;
    transition: all 0.3s ease; 
    margin-bottom: 14px;
    position: relative;
    overflow: hidden;
    
    &:hover {
        border-color: #6C30CC;
    }

    &.card-detail-active {
        border: 1px solid #6C30CC !important;
    }
    
    &.card-completed {
        border-left: 4px solid #4CAF50;
        
        &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            background-color: rgba(76, 175, 80, 0.05);
            z-index: 0;
        }
    }
    
    &.card-in-progress {
        border-left: 4px solid #FFC107;
        
        &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            background-color: rgba(255, 193, 7, 0.05);
            z-index: 0;
        }
    }
    
    &.card-not-started {
        opacity: 0.8;
    }
}

.card-status-indicator {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 8px;
    
    &.in-progress {
        .progress-dot {
            width: 8px;
            height: 8px;
            background-color: #FFC107;
            border-radius: 50%;
            animation: pulse 1.5s infinite;
        }
    }
}

@keyframes pulse {
    0% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 rgba(255, 193, 7, 0.7);
    }
    
    70% {
        transform: scale(1);
        box-shadow: 0 0 0 6px rgba(255, 193, 7, 0);
    }
    
    100% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 rgba(255, 193, 7, 0);
    }
}

.box_text{
    background: var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    opacity: 1;

}

/* Learning Content Card Styles */
.content-card {
  width: 100%;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0px 3px 6px rgba(0,0,0,0.1);
  margin-bottom: 24px;
}

.content-card-header {
  background-color: #6C30CC;
  color: white;
  display: flex;
  align-items: center;
  padding: 16px 24px;
}

.header-text {
  font-size: 18px;
  font-weight: 700;
  flex: 1;
}

.content-card-body {
  background-color: #eeeaf6;
  color: #000;
  padding: 24px;
  display: flex;
  flex-direction: column;
//   gap: 20px;
}
.content-card-body .content-text{
    font-size: 15px;
    font-weight: 400;
    color: #000;
    padding: 12px 0 24px 0;
    word-break: break-word;
}

.instruction-box {
  background-color: #FFF8C7;
  border-radius: 12px;
  padding: 16px 20px;
  font-size: 16px;
  color: #000;
  font-weight: 500;
  word-break: break-word;
}

.rating-buttons {
  display: flex;
  justify-content: space-between;
  margin-top: 24px;
}

.rating-btn {
  padding: 10px 16px;
  border-radius: 24px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  text-align: center;
  flex: 1;
  margin: 0 8px;
}

.too-basic {
  background-color: #F2F2F2;
}

.just-right {
  background-color: #F2F2F2;
}

.too-advanced {
  background-color: #F2F2F2;
}

.rating-btn:hover {
  opacity: 0.9;
}

.initiated-tag {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
}

.self-tag {
  background-color: #6C30CC;
  color: white;
}

.manager-tag {
  background-color: #32C2D5;
  color: white;
}

.compact-section {
  background: #F7F7F7 0% 0% no-repeat padding-box;
  border-radius: 24px;
  opacity: 1;
  padding: 16px 24px;
}

.section-subtitle {
  color: var(--unnamed-color-000000);
  opacity: 0.6;
}

.top-learners-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 12px;
}

.top-learner-item {
  position: relative;
  background: #FFFFFF;
  border-radius: 16px;
  padding: 12px;
  box-shadow: 0px 1px 4px rgba(0,0,0,0.1);
  height: 60px;
  display: flex;
  align-items: center;
}

.learner-rank {
  position: absolute;
  top: -8px;
  left: -8px;
  background: #6C30CC;
  color: white;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 11px;
}

.learner-profile {
  margin-right: 12px;
}

.learner-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
}

.learner-info {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.learner-name {
  font-size: 13px;
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #000;
}

.learner-journeys {
  font-size: 11px;
  color: #000;
}

.view-all-btn {
  color: #6C30CC;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
}

.view-all-btn:hover {
  opacity: 0.8;
}

/* Top Learners Modal Styles */
.top-learners-modal-content {
  padding: 0 16px;
}

.top-learners-explanation {
  color: #666;
  margin-bottom: 24px;
  word-break: break-word;
}

.mb-16 {
  margin-bottom: 16px;
}

.top-learners-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-height: 500px;
  overflow-y: auto;
}

.top-learner-row {
  display: flex;
  align-items: center;
  background: #FFFFFF;
  border-radius: 16px;
  padding: 16px;
  box-shadow: 0px 1px 4px rgba(0,0,0,0.1);
  position: relative;
}

.top-learner-rank-modal {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #6C30CC;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  margin-right: 16px;
}

.top-learner-info-modal {
  display: flex;
  align-items: center;
  flex: 1;
}

.top-learner-avatar-modal {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 16px;
}

.top-learner-details {
  display: flex;
  flex-direction: column;
}

.top-learner-name-modal {
  font-size: 16px;
  font-weight: 700;
  color: #000;
}

.top-learner-count-modal {
  font-size: 14px;
  color: #666;
}

.top-learners-search {
  display: flex;
  align-items: center;
}

.no-results {
  text-align: center;
  color: #666;
  margin: 32px 0;
  font-size: 14px;
}

.pagination-container {
  display: flex;
  justify-content: center;
  margin-top: 16px;
}

/* Tab styling */
#top-learners-modal .el-tabs__nav-wrap::after {
  height: 1px;
  background-color: #eeeeee;
}

#top-learners-modal .el-tabs__active-bar {
  background-color: #6C30CC;
  height: 3px;
}

#top-learners-modal .el-tabs__item {
  font-size: 15px;
  color: #666;
  height: 44px;
  line-height: 44px;
}

#top-learners-modal .el-tabs__item.is-active {
  color: #6C30CC;
  font-weight: 700;
}

#top-learners-modal .el-tabs__item:hover {
  color: #6C30CC;
}

/* Scrollbar styles for the learner lists */
.top-learners-list::-webkit-scrollbar,
.top-learners-grid-view::-webkit-scrollbar {
  width: 6px;
}

.top-learners-list::-webkit-scrollbar-track,
.top-learners-grid-view::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.top-learners-list::-webkit-scrollbar-thumb,
.top-learners-grid-view::-webkit-scrollbar-thumb {
  background: #d0d0d0;
  border-radius: 10px;
}

.top-learners-list::-webkit-scrollbar-thumb:hover,
.top-learners-grid-view::-webkit-scrollbar-thumb:hover {
  background: #bbbbbb;
}

.expand-icon-container {
    position: relative;
    z-index: 2;
}

.expand-icon {
    transition: all 0.25s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    opacity: 0.8;
}

.relative:hover .expand-icon {
    transform: scale(1.15);
    opacity: 1;
}

.relative:active .expand-icon {
    transform: scale(0.95);
}

.card-layer[style*="position: relative"] {
    z-index: 1;
}

.card-layer[style*="position: relative"]::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 0;
    height: 100%;
    background-color: rgba(108, 48, 204, 0.03);
    transition: width 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    z-index: -1;
}

.relative:hover .card-layer[style*="position: relative"]::after {
    width: 100%;
    left: 0;
    right: auto;
}

  </style>
<style lang="scss">
  #learning-journeys-dialog {
    .el-dialog {
      margin-top: 8vh !important;
      
      .el-dialog__header {
        padding: 0 !important;
      }
      
      .el-dialog__body {
        padding: 0 !important;
        height: 84vh;
        min-height: 847px;
        max-height: 1200px;
      }
    }
  }

  /* Modal styling overrides */
  #top-learners-modal {
    .el-dialog__header {
      text-align: center;
      padding: 16px 20px;
      border-bottom: 1px solid #eee;
    }

    .el-dialog__title {
      font-size: 20px;
      font-weight: 700;
      color: #000;
    }

    .el-dialog__body {
      padding: 0;
    }
    
    .el-dialog__headerbtn {
      top: 16px;
    }
    
    .el-pagination .btn-prev,
    .el-pagination .btn-next {
      color: #6C30CC;
      border-radius: 4px;
    }
    
    .el-pagination .number.active {
      color: #fff;
      background-color: #6C30CC;
    }
    
    .el-pagination .number:hover {
      color: #6C30CC;
    }
  }
  
  .top-learners-dialog {
    border-radius: 16px;
    overflow: hidden;
  }
  
  .modal-title {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    font-weight: 700;
  }
  
  .learners-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 24px 0;
    flex-wrap: wrap;
    gap: 16px;
    margin-bottom: 16px;
  }
  
  .learners-explanation {
    color: #666;
    font-size: 14px;
    max-width: 450px;
    word-break: break-word;
  }
  
  .top-learners-search {
    width: 240px;
  }
  
  .top-learners-modal-content {
    padding-bottom: 16px;
  }
  
  .top-learners-list-container {
    padding: 0 24px;
  }
  
  .top-learners-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
    max-height: 560px;
    overflow-y: auto;
    padding-right: 8px;
  }
  
  .top-learner-row {
    display: flex;
    align-items: center;
    background: #FFFFFF;
    border-radius: 12px;
    padding: 12px 16px;
    box-shadow: 0px 1px 3px rgba(0,0,0,0.08);
    position: relative;
    transition: transform 0.15s ease, box-shadow 0.15s ease;
  }
  
  .top-learner-row:hover {
    transform: translateY(-2px);
    box-shadow: 0px 3px 6px rgba(0,0,0,0.1);
  }
  
  .top-learner-rank-modal {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: #6C30CC;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    margin-right: 12px;
  }
  
  .top-learner-info-modal {
    display: flex;
    align-items: center;
    flex: 1;
  }
  
  .top-learner-avatar-modal {
    width: 38px;
    height: 38px;
    border-radius: 50%;
    object-fit: cover;
    margin-right: 12px;
    border: 1px solid #f0f0f0;
  }
  
  .top-learner-details {
    display: flex;
    flex-direction: column;
  }
  
  .top-learner-name-modal {
    font-size: 14px;
    font-weight: 700;
    color: #000;
  }
  
  .top-learner-count-modal {
    font-size: 13px;
    color: #666;
  }
  
  .modal-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 16px;
    margin-bottom: 16px;
    padding: 12px 24px 0;
    border-top: 1px solid #eee;
  }
  
  .total-count {
    font-size: 14px;
    color: #666;
  }
  
  .pagination-container {
    display: flex;
    justify-content: flex-end;
  }
  
  .no-results {
    text-align: center;
    color: #666;
    margin: 32px 0;
    font-size: 14px;
  }
</style>